<template>
  <section class="container">
    <CoolLightBox 
      :items="items" 
      :index="index"
      loop
      @close="index = null">
    </CoolLightBox>
    <full-page ref="fullpage" :options="options">
      <div
        class="section"
        id="section1sushi"
        data-anchor="sushi1"
        style="margin-bottom:15px;">
        <div class="fp-bg"></div>

        <div class="headerProyecto-sushi" id="headerProy">
          <v-container fluid>
            <v-row>
              <v-col cols="2"></v-col>
              <v-col cols="6">
                <v-row>
                  <div
                    class="titulo-proyecto-sushi"
                    style="position: absolute; font-family: 'Didot-bold'; color: black !important; font-size: calc(14.5px + 2.18125vw); z-index: 9999; opacity: 1;"
                  >
                    <p>True Sushi</p>
                  </div>
                </v-row>
                <v-row>
                  <div
                    style="position: relative; top:25vh; left: 10vw; font-family: 'Source'; color: black; font-size: calc(10.5px + 1.08125vw);"
                  >
                    Restaurant comida fusión japonesa – hawaiana
                  </div>
                </v-row>
                <v-row>
                  <div
                    style="position: relative; top:25vh; left: 10vw; font-family: 'Source'; color: black; font-size: calc(8.5px + 1.08125vw);"
                  >
                    Madrid 2019
                  </div>
                </v-row>
                <v-row>
                  <div
                    style="position: relative; top:25vh; left: 10vw; font-family: 'Source'; color: black; font-size: calc(10.5px + 0.78125vw);"
                  > Proyecto de colaboración para <a
                    href="https://asinteriorista.com/"
                    target="_blank"
                  >Estudio AS Interiorista </a>
                  </div>
                </v-row>
                <v-row>
                  <v-btn class="boton-volver-sushi" to="/proyectos"
                    >Volver</v-btn
                  >
                  <!--           <div>
                  <v-icon large style="position:absolute; bottom:1vh; left: 50vw; transition: all 0.45s ease-in-out;" @click="toggleCabProy()" v-if="cabeceraIsVisible" color="#372b5d">mdi-chevron-up</v-icon>
                  <v-icon large style="position:absolute; bottom:1vh; left: 50vw; transition: all 0.45s ease-in-out;" @click="toggleCabProy()" v-if="!cabeceraIsVisible" color="#372b5d">mdi-chevron-down</v-icon>
                  </div>-->
                </v-row>
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>
          </v-container>
        </div>

        <div class="slide" id="slide1-2">
          <div class="fp-bg"></div>
        </div>

      </div>

      <div class="section" data-anchor="sushi2" id="section2sushi">
        <v-container fluid>
          <v-row>
            <v-col cols="6">
              <div class="fondo-gris-sushi">
                <v-row class="row1sushi">
                  <v-col cols="2">
                    <p class="programa-sushi">Programa</p>
                  </v-col>
                  <v-col cols="10" class="textocol1-sushi">
                    <p class="texto1sushi">
                      Barra con pesca milagrosa, cocina caliente y fría en
                      barra, baños.
                    </p>
                  </v-col>
                </v-row>
                <v-row class="row2sushi">
                  <v-col cols="2">
                    <p class="programa-sushi">Colaboradores</p>
                    <br />
                  </v-col>
                  <v-col cols="10" class="textocol1-sushi">
                    <p class="texto1sushi">
                      Murales e ilustraciones por
                      <br />
                      <a
                        href="https://www.instagram.com/manilawallart/"
                        target="_blank"
                        style="font-family: 'Source-bold'; font-color: #372b5d !important;"
                        >@manilawallart_</a
                      >
                    </p>
                  </v-col>
                </v-row>
                <v-row class="row3sushi">
                  <v-col cols="2">
                    <p class="programa-sushi">Superficie</p>
                  </v-col>
                  <v-col cols="10" class="textocol1-sushi">
                    <p class="texto1sushi">26 m2</p>
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <v-col cols="6">
              <v-img :src="image_srcsushi3" class="img-sushi3" cover @click="setIndex(2)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-img :src="image_srcsushi2" class="img-sushi2" contain @click="setIndex(1)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
            <v-col cols="8"></v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-container>
      </div>

      <div class="section" data-anchor="sushi3" id="section3sushi">
        <v-container fluid>
          <v-row>
            <v-col cols="6">
              <v-img :src="image_srcsushi8" class="img-sushi8" contain @click="setIndex(7)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
            <v-col cols="5">
              <div class="fondo-gris-sushi2">
                <v-row>
                  <p class="texto2sushi">
                    Creamos este espacio con una arquitectura que reúne la
                    cultura japonesa y hawaiana, creando una fusión de éstas. Se
                    proyectó un mural en frente de la barra que le diere
                    carácter al espacio. Una gran pintura hecha a mano que evoca
                    la gran ola de KANAGAWA, por otra parte, en el techo se
                    instalaron lámparas de grandes peces de origami.
                  </p>
                </v-row>
                <v-row>
                  <p class="texto2sushi">
                    Otro sello distintivo del proyecto, es la barra en donde se
                    ubica una pequeña laguna en donde hay patitos de goma que
                    pueden pescarse con una caña mientras te instalas a comer.
                  </p>
                </v-row>
              </div>
              <v-img :src="image_srcsushi9" class="img-sushi9" contain @click="setIndex(8)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
            <v-col cols="1">
              <v-img :src="image_srcsushi7" class="img-sushi7" contain @click="setIndex(6)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div class="section" data-anchor="sushi4" id="section4sushi">
        <v-container fluid>
          <v-row>
            <v-col cols="4">
              <v-img :src="image_srcsushi4" class="img-sushi4" contain @click="setIndex(3)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
            <v-col cols="4">
              <v-img :src="image_srcsushi5" class="img-sushi5" contain @click="setIndex(4)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
            <v-col cols="4">
              <v-img :src="image_srcsushi6" class="img-sushi6" contain @click="setIndex(5)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </full-page>
  </section>
</template>

<script>
import store from "../store";
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
  data() {
    return {
      proyectos: [
        {
          numero: 2,
          numeroString: "02",
          isActive: false,
          route: "/sushi",
          titulo: "True Sushi",
          resumen: "Restaurant comida fusión japonesa – hawaiana",
          lugar: "Madrid",
          año: "2019",
          programa:
            "Barra con pesca milagrosa, cocina caliente y fría en barra, baños",
          colaboradores: ["@manilawallart"],
          superficie: "26 m2",
          descripcion: [
            "Creamos este espacio con una arquitectura que reúne la cultura japonesa y hawaiana, creando una fusión de éstas. Se proyectó un mural en frente de la barra que le diere carácter al espacio. Una gran pintura hecha a mano que evoca la gran ola de KANAGAWA, por otra parte, en el techo se instalaron lámparas de grandes peces de origami. Otro sello distintivo del proyecto, es la barra en donde se ubica una pequeña laguna en donde hay patitos de goma que pueden pescarse con una caña mientras te instalas a comer."
          ]
        }
      ],
      items: [
        {
          src: require("../assets/sushi1.jpg"),
        },
        {
          src: require("../assets/sushi2.jpg"),
        },
        {
          src: require("../assets/sushi3.jpg"),
        },
        {
          src: require("../assets/sushi4.jpg"),
        },
        {
          src: require("../assets/sushi5.jpg"),
        },
        {
          src: require("../assets/sushi6.jpg"),
        },
        {
          src: require("../assets/sushi7.jpg"),
        },
        {
          src: require("../assets/Trueshushi1.png"),
        },
        {
          src: require("../assets/2.jpg"),
        },
      ],
      index: null,
      posicionLista: -25,
      proyectoSeleccionado: 2,
      image_srcsushi1: require("../assets/sushi1.jpg"),
      image_srcsushi2: require("../assets/sushi2.jpg"),
      image_srcsushi3: require("../assets/sushi3.jpg"),
      image_srcsushi4: require("../assets/sushi4.jpg"),
      image_srcsushi5: require("../assets/sushi5.jpg"),
      image_srcsushi6: require("../assets/sushi6.jpg"),
      image_srcsushi7: require("../assets/sushi7.png"),
      image_srcsushi8: require("../assets/Trueshushi1.png"),
      image_srcsushi9: require("../assets/2.jpg"),
      options: {
        licenseKey: "265864DA-1DE54052-9BEBB977-EF50CFB8",
        parallax: true,
        parallaxKey: [
          "Y29sZWN0aXZvYWxxdWltaWEuY2xfYmxNY0dGeVlXeHNZWGc9OTJR",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfdjhXY0dGeVlXeHNZWGc9QVEw",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfNjI0Y0dGeVlXeHNZWGc9WVlP"
        ],
        // parallaxKey: '7CD7B03B-68104BF5-88FFE8B4-2585F4CC',
        // activation-key for domain colectivoalquimia.cl: Y29sZWN0aXZvYWxxdWltaWEuY2xfcmg0Y0dGeVlXeHNZWGc9bHhi
        autoScrolling: true,
        scrollbar: false,
        slidesNavigation: false,
        controlArrows: false,
        verticalCentered: false,
        anchors: ["sushi1", "sushi2", "sushi3", "sushi4"],
        bigSectionsDestination: "top",
        scrollingSpeed: "700",
        parallaxOptions: {
          type: "cover",
          percentage: 99,
          property: "translate"
        },
        onLeave: function(origin, destination, direction) {
          console.log(destination);
          console.log(direction);
          if (origin.index == 0) {
            store.commit("esconder");
            document.getElementById("headerProy").style.top = "-60vh";
          } else if (origin.index == 1 && direction == "up") {
            //document.getElementById("headerProy").style.top = "0vw";
            // store.commit("mostrar");
          }
        },
        afterLoad: function(origin, destination, direction) {
          console.log(destination);
          console.log(direction);
          if (origin.index == 0) {
            setTimeout(function() {
              document.getElementById("headerProy").style.top = "0vh";
            }, 2000);
          } else if (origin.index == 1 && direction == "up") {
            //document.getElementById("headerProy").style.top = "0vw";
            // store.commit("mostrar");
          }
        }
      }
    };
  },
  components: {
    CoolLightBox
  },
  metaInfo: {
    title: "Proyectos",
    titleTemplate: "%s | True Sushi"
  },
  computed: {
    yLista() {
      return `transform: translateY(${this.posicionLista}%)`;
    }
  },
  mounted() {
    setTimeout(function() {
      document.getElementById("headerProy").style.top = "-60vh";
    }, 2000);
    this.$refs.fullpage.api.moveTo(1, 0);
  },
  methods: {
    isOnTop() {
      if (this.$refs.fullpage.api.getActiveSection().anchor == "pro1") {
        return true;
      } else {
        return false;
      }
    },
    setIndex(index) {
      this.index = index;
    },
    getSection() {
      return this.$refs.fullpage.api.getActiveSection().anchor;
    },
    getSectionIndex() {
      return this.$refs.fullpage.api.getActiveSection().index;
    },
    selectTitle() {
      this.$refs.fullpage.api.moveTo(2);
    }
  }
};
</script>

<style>
.fp-bg {
  background-size: cover;
  transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden; /* Chrome, Safari, Opera */
  backface-visibility: hidden;
}
.container {
  padding: 0px;
  margin: 0px;
  transition: all 0.45s ease-in-out;
  transition: all 0.45s cubic-bezier(0.55, 0, 0.1, 1);
}
.section {
  height: 100vh;
  z-index: -1;
}
#section1sushi {
}
#section2sushi {
  background-size: cover;
}
#section3sushi {
  background-size: cover;
}
#section4sushi {
  background-size: cover;
}
#slide1-1 .fp-bg {
  background-image: url("../assets/1.jpg");
  background-size: cover;
  background-position: center 10%;
}
#slide1-2 .fp-bg {
  background-image: url("../assets/2.jpg");
  background-size: cover;
  background-position: bottom 10%;
}
#slide1-3 .fp-bg {
  background-image: url("../assets/3.jpg");
  background-size: cover;
  background-position: center 80%;
}
#slide1-4 .fp-bg {
  background-image: url("../assets/4.jpg");
  background-size: cover;
  background-position: center 80%;
}
.titulo-apiadate {
  position: absolute;
  height: 6vw;
  top: 40vh;
  padding: 0em;
  font-size: calc(14.5px + 2.98125vw);
  font-family: "Source-bold";
  color: white;
  text-decoration: none;
  text-shadow: 0px 0px #000000;
  transition-duration: 625ms;
  transition: opacity 0.5s, transform 0.5s;
  z-index: 99;
}
.headerProyecto-sushi {
  position: fixed;
  top: 0;
  background-color: #fff;
  height: 60vh;
  width: 100%;
  transition: 925ms;
  z-index: 999;
}

@media (min-width: 960px) {
  .texto1sushi {
    font-size: calc(4.5px + 1.01875vw);
    color: black;
    padding-left: 30px;
    padding-right: 5vw;
    font-family: "Source";
  }
  .texto2sushi {
    top: 5vh;
    font-size: calc(2.5px + 1.01875vw);
    color: black;
    padding-right: 1vw;
  }
  .img-sushi2 {
    position: absolute;
    bottom: 1vh;
    right: 28vw;
    height: 60vh;
    cursor: pointer;
  }
  .img-sushi3 {
    bottom: 0vh;
    right: 5vw;
    height: 95vh;
    cursor: pointer;
  }
  .img-sushi4 {
    position: absolute;
    top: 10vh;
    left: 10vw;
    width: 25vw;
    cursor: pointer;
  }
  .img-sushi5 {
    position: absolute;
    top: 5vh;
    left: 38vw;
    width: 30vw;
    cursor: pointer;
  }
  .img-sushi6 {
    position: absolute;
    top: 10vh;
    width: 25vw;
    right: 5vw;
    cursor: pointer;
  }
  .img-sushi7 {
    position: absolute;
    top: 5vh;
    right: 0vw;
    width: 10vw;
    cursor: pointer;
    z-index: 9999;
  }
  .img-sushi8 {
    position: absolute;
    top: 1vh;
    left: 1vw;
    width: 54vw;
    cursor: pointer;
    z-index: 9;
  }
  .img-sushi9 {
    position: absolute;
    bottom: 1vh;
    right: 1vw;
    width: 40vw;
    cursor: pointer;
    z-index: 9;
  }
  .programa-sushi {
    color: black;
    white-space: pre;
    font-size: calc(4.5px + 0.68125vw);
  }
  .fondo-gris-sushi {
    position: absolute;
    background-color: #e3dfe0 !important;
    left: 8vw;
    top: 0;
    margin-top: 1vh;
    max-width: 30vw;
    min-height: 36vh;
    padding-left: 1vw;
    padding-right: 0vw;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .fondo-gris-sushi2 {
    left: 5vw;
    position: relative;
    background-color: #e3dfe0 !important;
    right: 5vw;
    padding-left: 3vw;
    padding-right: 1vw;
    margin-right: 5vw;
    max-width: 37vw;
    max-height: 80vh;
    padding-top: 50px;
    padding-bottom: 1vh;
    z-index: 9;
  }
  .proyectos {
    position: fixed;
    top: 55vh;
    width: 50vw;
    left: 15vw;
    z-index: 99;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  li {
    height: 6vw;
  }
  .nProyecto {
    position: relative;
    bottom: 6vh;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    transition: opacity 0.5s, transform 0.5s;
  }
  .nTotalProyectos {
    position: fixed;
    bottom: 5vh;
    left: 15vw;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    color: white;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
    opacity: 0.5;
  }
  .titulo-proyecto-sushi {
    position: absolute;
    font-family: "Didot-bold";
    color: black;
    font-size: calc(14.5px + 2.18125vw);
    top: 15vh;
    left: 25vw;
  }
  .titulo-proyecto-sushi::before {
    content: "";
    position: absolute;
    top: 35px;
    right: 100%;
    cursor: default;
    width: 1.5em;
    height: 3px;
    background: #000;
    z-index: 3;
  }
  .subtitulo-proyecto {
    font-family: "Source";
    font-size: calc(10.5px + 1.78125vw);
  }
  .texto-card {
    font-family: "Source";
    font-size: 20px;
    font-weight: 400;
    padding-top: 20px;
    color: #ffffff;
    line-height: 1;
  }
  .boton-volver-sushi {
    position: absolute;
    font-family: "Source";
    bottom: 3vh;
    left: 25vw;
    z-index: 9999;
  }
}

@media (max-width: 960px) {
  .texto1sushi {
    position: relative;
    top: 0vh;
    font-size: calc(7.5px + 0.91875vw);
    color: black;
    padding-right: 1vw;
    margin-top: 3vh;
    margin-bottom: 0 !important;
  }
  .texto2sushi {
    top: 5vh;
    font-size: calc(6.5px + 0.91875vw);
    color: black;
    padding-right: 1vw;
  }
  .boton-volver {
    position: absolute;
    font-family: "Source";
    bottom: 20vw;
    left: 5vw;
    z-index: 9999;
  }
  .img-sushi2 {
    position: absolute;
    bottom: 1vh;
    left: 1vw;
    height: 40vh;
  }
  .img-sushi3 {
    top: 1vh;
    right: 1vw;
    height: 55vh;
  }
  .img-sushi4 {
    position: absolute;
    top: 15vh;
    left: 3vw;
    width: 40vw;
  }
  .img-sushi5 {
    position: absolute;
    top: 50vh;
    left: 25vw;
    width: 50vw;
  }
  .img-sushi6 {
    position: absolute;
    top: 15vh;
    width: 40vw;
    right: 3vw;
  }
  .img-sushi7 {
    position: absolute;
    top: 15vh;
    right: 0vw;
    width: 10vw;
    z-index: 9999;
  }
  .img-sushi8 {
    position: absolute;
    bottom: 10vh;
    left: 1vw;
    height: 30vh;

    z-index: 1;
  }
  .img-sushi9 {
    position: absolute;
    bottom: 5vh;
    left: 1vw;
    width: 0vw;
  }
  .row1sushi {
    position: relative;
    margin-top: 1px;
    min-height: 5vh;
    padding: 0;
  }
  .row2sushi {
    position: relative;
    margin-top: 1px;
    min-height: 5vh;
  }
  .row3sushi {
    position: relative;
    margin-top: 1px;
    min-height: 5vh;
  }
  .fondo-gris-sushi {
    position: relative;
    top: 0;
    left: 1vw;
    background-color: #e3dfe0 !important;
    max-width: 70vw;
    min-height: 40vh;
    margin-top: 10vh;
    max-height: 80vh;
    padding-top: 5px;
    padding-right: 1px;
    z-index: 5;
  }
  .fondo-gris-sushi2 {
    position: relative;
    background-color: #e3dfe0 !important;
    min-height: 40vh;
    max-height: 60vh;
    width: 85vw;
    padding: 7vw;
    right: 45vw;
    margin-top: 10vh;
    padding-bottom: 1vh;
    bottom: 2vh;
    z-index: 10;
  }
  .textocol1-sushi {
    line-height: 1.5;
  }
  .programa-sushi {
    position: relative;
    top: 0vh;
    padding-left: 2vw;
    color: black;
    white-space: pre;
    font-size: calc(4.5px + 1.68125vw);
  }
  .proyectos {
    position: fixed;
    top: 60vh;
    width: 50vw;
    left: 15vw;
    z-index: 99;
    white-space: nowrap;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  li {
    white-space: nowrap;
  }
  .nProyecto {
    position: relative;
    bottom: 4vh;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 60px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    transition: opacity 0.5s, transform 0.5s;
  }
  .nTotalProyectos {
    position: fixed;
    bottom: 15vh;
    left: 15vw;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    color: white;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
    opacity: 0.5;
  }
  .titulo-proyecto-sushi {
    position: absolute;
    font-family: "Didot-bold";
    color: black;
    font-size: calc(20.5px + 2.18125vw);
    top: 20vh;
    left: 25vw;
  }
  .subtitulo-proyecto {
    font-family: "Source";
    font-size: calc(10.5px + 1.78125vw);
  }
  .texto-card {
    font-family: "Source";
    font-size: 20px;
    font-weight: 400;
    padding-top: 20px;
    color: #000000;
    line-height: 1;
  }
  .boton-volver-sushi {
    position: relative;
    font-family: "Source";
    top: 50vw;
    left: 10vw;
    z-index: 9999;
  }
}
</style>
